export const PhoneMask = (phone) => {
    if(!phone) return phone
    return phone.length < 11
        ? phone.replace(/^(\d{2})(\d{4})(\d{4})./, '($1) $2-$3')
        : phone.replace(/^(\d{2})(\d{5})(\d{4})./, '($1) $2-$3');
}


export const RemoveMask = (phone) => phone?.replaceAll(/[^0-9.]/g, '');
